<template>
  <div>
    <div v-if="openType === 0"></div>
    <div v-else>
      <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用药对象" prop="pId">
              <el-select v-fixZoom :disabled="openType === 2" v-model="addEditForm.pId" filterable placeholder="请选择" style="width:100%;">
                <el-option v-for="item in elderlyArr" :key="item.index" :label="item.name" :value="item.id">
                  <span>{{ getSelectElderlyShow(item) }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务人员" prop="svsEspId">
              <el-select v-fixZoom v-model="addEditForm.svsEspId" filterable placeholder="请选择" style="width:100%;">
                <el-option v-for="item in servicePersonArr" :key="item.index" :label="item.service_personnel_name" :value="item.id">
                  <span>{{ getSelectServicePersonShow(item) }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="药物名称" prop="medName">
              <el-input v-model="addEditForm.medName" placeholder="输入药物名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="用药方式" :required="true">
              <el-row>
                <el-col :span="2"><span>&nbsp;每次</span></el-col>
                <el-col :span="5">
                  <el-form-item prop="descPerTimeNum">
                  <el-input-number v-model="addEditForm.descPerTimeNum" controls-position="right" size="mini" style="width: 90%;"></el-input-number>
                </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="descPerTimeUnit">
                  <el-select v-fixZoom v-model="addEditForm.descPerTimeUnit" filterable allow-create clearable placeholder="请选择" size="mini" style="width: 90%">
                    <el-option v-for="item in descPerTimeUnitArr" :key="item.name" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
                </el-col>
                <el-col :span="1"><span>，</span></el-col>
                <el-col :span="12">
                  <el-form-item prop="descPerTimeMode">
                  <el-select v-fixZoom v-model="addEditForm.descPerTimeMode" filterable allow-create clearable placeholder="请选择" size="mini" style="width: 100%">
                    <el-option v-for="item in descPerTimeModeArr" :key="item.name" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
                </el-col>
              </el-row>
<!--              <el-input v-model="addEditForm.descPerTime" placeholder="输入服用方式"></el-input>-->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="周期类型" prop="periodType">
              <el-select v-fixZoom v-model="addEditForm.periodType" filterable placeholder="请选择" style="width:100%;">
                <el-option v-for="item in periodTypeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="周期内次数" prop="timesPerPeriod">
              <el-input v-model="addEditForm.timesPerPeriod" placeholder="输入次数" onkeyup="value=value.replace(/[^\d]/g,'')">
                <template slot="append">次</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始服用时间" prop="startTime">
              <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.startTime"
                              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束服用时间" prop="endTime">
              <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.endTime"
                              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="注意事项" prop="descOther">
          <el-input type="textarea" :rows="2" v-model="addEditForm.descOther" placeholder="输入注意事项"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="周期内已服次数" prop="cntPeriod">
              <el-input v-model="addEditForm.cntPeriod" placeholder="输入次数" onkeyup="value=value.replace(/[^\d]/g,'')">
                <template slot="append">次</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最后服用时间" prop="tmLastUse">
              <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.tmLastUse"
                              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="height: 50px">
      <el-row v-if="openType !== 0" style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
      <el-row v-else style="margin: 0 20px">
        <div class="cancel-btn" style="float: right" @click="closeAddEdit()">
          <span>关闭</span>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import {queryelderlyhasbed} from '../../../api/yanglaoyuan/elderly'
import {queryserviceperson} from '../../../api/yanglaoyuan'
import {updatemedperson} from '../../../api/yanglaoyuan/eservice'

export default {
  name: 'addEditMedPerson',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    medPersonObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      eId: 0,
      espId: 0,
      espName: '',
      // 打开类型 0查看 1新增 2编辑
      openType: 0,
      row: '',
      elderlyArr: [],
      servicePersonArr: [],
      periodTypeArr: [{id: 0, name: '一次'}, {id: 1, name: '每天'}, {id: 2, name: '每周'}, {id: 3, name: '每月'}],
      descPerTimeUnitArr: [{name: '片'}, {name: '克'}, {name: '瓶'}, {name: '毫升'}],
      descPerTimeModeArr: [{name: '饭前'}, {name: '饭后'}, {name: '饭前饭后不限'}],

      addEditForm: {
        pId: '',
        medName: '',
        periodType: '',
        timesPerPeriod: '',
        descPerTime: '',
        descPerTimeNum: 1,
        descPerTimeUnit: '片',
        descPerTimeMode: '饭前',
        descOther: '',
        startTime: '',
        endTime: '',
        cntPeriod: '',
        tmLastUse: '',
        svsEspId: ''
      },
      addEditRules: {
        pId: [{required: true, message: '请选择用药对象', trigger: 'change'}],
        svsEspId: [{required: true, message: '请选择服务人员', trigger: 'change'}],
        medName: [{ required: true, message: '请输入药物名称', trigger: 'blur' }],
        // descPerTime: [{ required: true, message: '请输入服用方式', trigger: 'blur' }],
        periodType: [{required: true, message: '请选择周期类型', trigger: 'change'}],
        timesPerPeriod: [{ required: true, message: '请输入周期内次数', trigger: 'blur' }],
        startTime: [{required: true, message: '请选择开始服用时间', trigger: 'change'}],
        endTime: [{required: true, message: '请选择结束服用时间', trigger: 'change'}],

        descPerTimeNum: [{required: true, message: '请输入数量', trigger: 'blur'}],
        descPerTimeUnit: [{required: true, message: '请选择', trigger: 'change'}],
        descPerTimeMode: [{required: true, message: '请选择', trigger: 'change'}]
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let loginResp = this.$store.state.user.LoginResp
      this.eId = loginResp.entity_id
      this.espId = loginResp.syspersonid
      this.espName = loginResp.personname

      this.openType = this.medPersonObj.openType
      this.row = this.medPersonObj.row

      if (this.openType === 2) {
        let descPerTime = this.row.desc_per_time
        this.addEditForm.descPerTimeNum = descPerTime.match(/\d+/g)[0]
        this.addEditForm.descPerTimeMode = descPerTime.split('，')[1]
        this.addEditForm.descPerTimeUnit = descPerTime.split('，')[0].substring(descPerTime.indexOf(this.addEditForm.descPerTimeNum) + this.addEditForm.descPerTimeNum.length, descPerTime.split('，')[0].length)

        this.addEditForm.pId = this.row.pid
        this.addEditForm.medName = this.row.med_name
        this.addEditForm.periodType = this.row.period_type
        this.addEditForm.timesPerPeriod = this.row.times_per_period
        this.addEditForm.descPerTime = this.row.desc_per_time
        this.addEditForm.descOther = this.row.desc_other
        this.addEditForm.startTime = this.row.start_time
        this.addEditForm.endTime = this.row.end_time
        this.addEditForm.cntPeriod = this.row.cnt_period
        this.addEditForm.tmLastUse = this.row.tm_last_use === '0000-00-00 00:00:00' ? '' : this.row.tm_last_use
        this.addEditForm.svsEspId = this.row.esp_svs_id
      }

      this.getElderlyData()
      this.getServicePersonData()
    },
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let buildName = item.build_name && item.build_name !== '' ? item.build_name : '--'
      let floorName = item.floor_name && item.floor_name !== '' ? item.floor_name : '--'
      let roomName = item.room && item.room !== '' ? item.room : '--'
      let bedName = item.bed_name && item.bed_name !== '' ? item.bed_name : '--'
      return elderlyName + ' / ' + buildName + '--' + floorName + '--' + roomName + '--' + bedName
    },
    getSelectServicePersonShow (item) {
      let servicePersonName = item.service_personnel_name && item.service_personnel_name !== '' ? item.service_personnel_name : '--'
      let idNumber = item.service_personnel_identity_card_number && item.service_personnel_identity_card_number !== '' ? item.service_personnel_identity_card_number : '--'
      return servicePersonName + ' / ' + idNumber
    },

    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.openType === 1) {
            this.sendAdd()
          } else if (this.openType === 2) {
            this.sendEdit()
          }
        }
      })
    },
    sendAdd () {
      let elderly = this.elderlyArr.find(r => r.id === this.addEditForm.pId)
      let svsEsp = this.servicePersonArr.find(r => r.id === this.addEditForm.svsEspId)
      let descPerTime = '每次' + this.addEditForm.descPerTimeNum + this.addEditForm.descPerTimeUnit + '，' + this.addEditForm.descPerTimeMode
      let data = {
        oper_type: 0,
        eid: this.eId,
        pid: this.addEditForm.pId,
        cin_id: elderly.checkinid,
        med_name: this.addEditForm.medName,
        period_type: this.addEditForm.periodType,
        times_per_period: parseInt(this.addEditForm.timesPerPeriod),
        desc_per_time: descPerTime,
        desc_other: this.addEditForm.descOther,
        start_time: this.addEditForm.startTime,
        end_time: this.addEditForm.endTime,
        cnt_period: this.addEditForm.cntPeriod !== '' ? parseInt(this.addEditForm.cntPeriod) : 0,
        tm_last_use: this.addEditForm.tmLastUse,
        esp_svs_id: this.addEditForm.svsEspId,
        esp_svs_name: svsEsp.service_personnel_name,
        esp_id: this.espId,
        esp_name: this.espName
      }
      updatemedperson(data).then(res => {
        this.$notify({title: '成功', message: '成功登记用药', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    sendEdit () {
      let elderly = this.elderlyArr.find(r => r.id === this.addEditForm.pId)
      let svsEsp = this.servicePersonArr.find(r => r.id === this.addEditForm.svsEspId)
      let descPerTime = '每次' + this.addEditForm.descPerTimeNum + this.addEditForm.descPerTimeUnit + '，' + this.addEditForm.descPerTimeMode
      let data = {
        oper_type: 1,
        eid: this.eId,
        id: this.row.id,
        pid: this.addEditForm.pId,
        cin_id: elderly.checkinid,
        med_name: this.addEditForm.medName,
        period_type: this.addEditForm.periodType,
        times_per_period: parseInt(this.addEditForm.timesPerPeriod),
        desc_per_time: descPerTime,
        desc_other: this.addEditForm.descOther,
        start_time: this.addEditForm.startTime,
        end_time: this.addEditForm.endTime,
        cnt_period: this.addEditForm.cntPeriod !== '' ? parseInt(this.addEditForm.cntPeriod) : 0,
        tm_last_use: this.addEditForm.tmLastUse,
        esp_svs_id: this.addEditForm.svsEspId,
        esp_svs_name: svsEsp.service_personnel_name,
        esp_id: this.espId,
        esp_name: this.espName
      }
      updatemedperson(data).then(res => {
        this.$notify({title: '成功', message: '成功登记用药', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },

    // 访问接口
    // 查询老人
    getElderlyData () {
      let data = {
        e_id: this.eId
      }
      queryelderlyhasbed({}, data).then(res => {
        this.elderlyArr = res.data.elderly
      })
    },
    // 查询机构人员
    getServicePersonData () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        e_id: this.eId
      }
      queryserviceperson(params, data).then(res => {
        this.servicePersonArr = res.data.serviceperson
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditMedPerson.vue